export default __webpack_public_path__ + "static/media/VINCI_logo_white.f8c75aae.png";